module.exports = __webpack_public_path__ + "img/mmr.92e9f832.svg";